import useSWR from "swr";
import { fetcher } from "../lib/api";
import { useConfig, useStats } from "../hooks/useHoodbank";
import { Hero } from "../components/site/Hero";
import { StatsBar } from "../components/site/StatsBar";
import { HowItWorks } from "../components/site/HowItWorks";
import { Calculator } from "../components/site/Calculator";
import { AutoCompoundSection } from "../components/site/AutoCompoundSection";
import { HolderPie } from "../components/site/HolderPie";
import { StatementGenerator } from "../components/site/StatementGenerator";
import { fmtEth } from "../lib/api";

const RecentPayouts = ({ config }) => {
  const { data } = useSWR("/distributions?limit=8", fetcher, { refreshInterval: 30000 });
  const rows = data?.distributions || [];
  if (rows.length === 0) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 py-12">
      <p className="font-mono text-xs tracking-[0.2em] text-[#00C805] uppercase mb-6">Recent payouts</p>
      <div className="card-surface rounded-2xl divide-y divide-white/5" data-testid="recent-payouts-list">
        {rows.map((d) => (
          <div key={d.tx_hash} className="flex items-center justify-between px-6 py-4 font-mono text-sm">
            <span className="text-neutral-500">Cycle #{d.cycle}</span>
            <span className="text-[#00C805]">{fmtEth(d.amount_eth)} ETH</span>
            <a href={d.explorer_link} target="_blank" rel="noreferrer" className="text-neutral-400 hover:text-white transition-colors duration-200">
              {d.tx_hash.slice(0, 12)}… ↗
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default function Landing() {
  const config = useConfig();
  const stats = useStats();
  return (
    <div data-testid="landing-page">
      <Hero config={config} />
      <StatsBar stats={stats} config={config} />
      <HowItWorks />
      <Calculator stats={stats} />
      <AutoCompoundSection />
      <RecentPayouts config={config} />
      <HolderPie />
      <StatementGenerator />
    </div>
  );
}
